import { render, staticRenderFns } from "./BuyerAutoPauseParameters.vue?vue&type=template&id=c9e6fef2&lang=true"
import script from "./BuyerAutoPauseParameters.vue?vue&type=script&lang=js"
export * from "./BuyerAutoPauseParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports